import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "regenerator-runtime/runtime.js";
import Vue from 'vue';
import { getMatchedComponentsInstances, getChildrenComponentInstancesUsingFetch, promisify, globalHandleError, sanitizeComponent } from './utils';
import NuxtError from '../layouts/error.vue';
import NuxtLoading from './components/nuxt-loading.vue';
import '../assets/reset.scss';
import '../assets/tickethead/styles/main.scss';
import '../assets/global.scss';
import '../primevue/resources/themes/bam-md/theme.css';
import '../node_modules/primevue/resources/primevue.min.css';
import '../node_modules/primeicons/primeicons.css';
import '../node_modules/leaflet/dist/leaflet.css';
import _4d6bf9b0 from '../layouts/default_v2.vue';
import _6f6c098b from '../layouts/default.vue';
import _1e723bf9 from '../layouts/organizer.vue';
import _00e6bcf3 from '../layouts/profile.vue';
var layouts = {
  "_default_v2": sanitizeComponent(_4d6bf9b0),
  "_default": sanitizeComponent(_6f6c098b),
  "_organizer": sanitizeComponent(_1e723bf9),
  "_profile": sanitizeComponent(_00e6bcf3)
};
export default {
  render: function render(h, props) {
    var loadingEl = h('NuxtLoading', {
      ref: 'loading'
    });
    var layoutEl = h(this.layout || 'nuxt');
    var templateEl = h('div', {
      domProps: {
        id: '__layout'
      },
      key: this.layoutName
    }, [layoutEl]);
    var transitionEl = h('transition', {
      props: {
        name: 'layout',
        mode: 'out-in'
      },
      on: {
        beforeEnter: function beforeEnter(el) {
          // Ensure to trigger scroll event after calling scrollBehavior
          window.$nuxt.$nextTick(function () {
            window.$nuxt.$emit('triggerScroll');
          });
        }
      }
    }, [templateEl]);
    return h('div', {
      domProps: {
        id: '__nuxt'
      }
    }, [loadingEl, transitionEl]);
  },
  data: function data() {
    return {
      isOnline: true,
      layout: null,
      layoutName: '',
      nbFetching: 0
    };
  },
  beforeCreate: function beforeCreate() {
    Vue.util.defineReactive(this, 'nuxt', this.$options.nuxt);
  },
  created: function created() {
    // Add this.$nuxt in child instances
    this.$root.$options.$nuxt = this;
    if (process.client) {
      // add to window so we can listen when ready
      window.$nuxt = this;
      this.refreshOnlineStatus();
      // Setup the listeners
      window.addEventListener('online', this.refreshOnlineStatus);
      window.addEventListener('offline', this.refreshOnlineStatus);
    }
    // Add $nuxt.error()
    this.error = this.nuxt.error;
    // Add $nuxt.context
    this.context = this.$options.context;
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.$loading = _this.$refs.loading;
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  watch: {
    'nuxt.err': 'errorChanged'
  },
  computed: {
    isOffline: function isOffline() {
      return !this.isOnline;
    },
    isFetching: function isFetching() {
      return this.nbFetching > 0;
    }
  },
  methods: {
    refreshOnlineStatus: function refreshOnlineStatus() {
      if (process.client) {
        if (typeof window.navigator.onLine === 'undefined') {
          // If the browser doesn't support connection status reports
          // assume that we are online because most apps' only react
          // when they now that the connection has been interrupted
          this.isOnline = true;
        } else {
          this.isOnline = window.navigator.onLine;
        }
      }
    },
    refresh: function refresh() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var pages, promises, _t;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              pages = getMatchedComponentsInstances(_this2.$route);
              if (pages.length) {
                _context3.next = 1;
                break;
              }
              return _context3.abrupt("return");
            case 1:
              _this2.$loading.start();
              promises = pages.map(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(page) {
                  var p, _iterator, _step, component;
                  return regeneratorRuntime.wrap(function (_context2) {
                    while (1) switch (_context2.prev = _context2.next) {
                      case 0:
                        p = []; // Old fetch
                        if (page.$options.fetch && page.$options.fetch.length) {
                          p.push(promisify(page.$options.fetch, _this2.context));
                        }
                        if (page.$options.asyncData) {
                          p.push(promisify(page.$options.asyncData, _this2.context).then(function (newData) {
                            for (var key in newData) {
                              Vue.set(page.$data, key, newData[key]);
                            }
                          }));
                        }

                        // Wait for asyncData & old fetch to finish
                        _context2.next = 1;
                        return Promise.all(p);
                      case 1:
                        // Cleanup refs
                        p = [];
                        if (page.$fetch) {
                          p.push(page.$fetch());
                        }
                        // Get all component instance to call $fetch
                        _iterator = _createForOfIteratorHelper(getChildrenComponentInstancesUsingFetch(page.$vnode.componentInstance));
                        try {
                          for (_iterator.s(); !(_step = _iterator.n()).done;) {
                            component = _step.value;
                            p.push(component.$fetch());
                          }
                        } catch (err) {
                          _iterator.e(err);
                        } finally {
                          _iterator.f();
                        }
                        return _context2.abrupt("return", Promise.all(p));
                      case 2:
                      case "end":
                        return _context2.stop();
                    }
                  }, _callee2);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
              _context3.prev = 2;
              _context3.next = 3;
              return Promise.all(promises);
            case 3:
              _context3.next = 5;
              break;
            case 4:
              _context3.prev = 4;
              _t = _context3["catch"](2);
              _this2.$loading.fail(_t);
              globalHandleError(_t);
              _this2.error(_t);
            case 5:
              _this2.$loading.finish();
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[2, 4]]);
      }))();
    },
    errorChanged: function errorChanged() {
      if (this.nuxt.err) {
        if (this.$loading) {
          if (this.$loading.fail) {
            this.$loading.fail(this.nuxt.err);
          }
          if (this.$loading.finish) {
            this.$loading.finish();
          }
        }
        var errorLayout = (NuxtError.options || NuxtError).layout;
        if (typeof errorLayout === 'function') {
          errorLayout = errorLayout(this.context);
        }
        this.nuxt.errPageReady = true;
        this.setLayout(errorLayout);
      }
    },
    setLayout: function setLayout(layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default';
      }
      this.layoutName = layout;
      this.layout = layouts['_' + layout];
      return this.layout;
    },
    loadLayout: function loadLayout(layout) {
      if (!layout || !layouts['_' + layout]) {
        layout = 'default';
      }
      return Promise.resolve(layouts['_' + layout]);
    }
  },
  components: {
    NuxtLoading: NuxtLoading
  }
};